import * as React from 'react'
import {useEffect, useState} from 'react';
import { Card, Button, Table } from 'react-bootstrap'
import { SelectableUser, UserClaimable } from '../../contexts/ContextTypes';
import { useAdminContext } from '../../contexts/AdminContext';

interface UnapprovedUserListProps {
  field: string,
  setHidden?: React.Dispatch<React.SetStateAction<boolean>>
}

export default function UnapprovedClaimableList(props : React.PropsWithChildren<UnapprovedUserListProps>) {
  const { getUnapprovedUserClaimableList, setClaimableField } = useAdminContext(); 
  const [claimedUserRows, setClaimedUserRows] = useState<Array<JSX.Element>>([]);
  const [updateSub, updatePub] = useState<number>(0);

  useEffect(() => {
    getUnapprovedUserClaimableList(props.field).then((res) => {
      setClaimedUserRows(res.map(claimToRow));
      if (props.setHidden !== undefined) {
        props.setHidden(res.length === 0);
      }
    });

    function claimToRow(user : SelectableUser) : JSX.Element {
      return (
        <tr key={user.uid}>
          <td className='text-center'>
            <>{`${user.firstName} ${user.lastName}`}</>
          </td>
          <td className='text-center'>
            <Button variant='success' className='d-inline-flex' onClick={async () => {
              await setClaimableField(user.uid, props.field, UserClaimable.claimedAndApproved);
              updatePub(updateSub + 1);
            }}
            >
              Approve
            </Button>
          </td>
          <td className='text-center'>
            <Button variant='danger' className='d-inline-flex' onClick={async () => {
                await setClaimableField(user.uid, props.field, UserClaimable.notClaimed);
                updatePub(updateSub + 1);
            }}
            >
              Reject
            </Button>
          </td>
        </tr>
      );
    }
  }, [getUnapprovedUserClaimableList, props, setClaimableField, updateSub]);

  return (
    <Card>
      <Card.Header>
        <h2>Users claiming: {props.field}</h2>
      </Card.Header>
      <Card.Body>
        <Table>
            <thead>
              <tr>
                <th className='text-center'>Name</th>
                <th className='text-center'>Approve</th>
                <th className='text-center'>Do not Approve</th>
              </tr>
            </thead>
            <tbody>
              {claimedUserRows}
            </tbody>
          </Table>
      </Card.Body>
    </Card>
  )
}
